import * as React from 'react';
import DefaultICheckbox from './index';
const Checkbox = (props) => {
    const { input, id, ...restProps } = props;
    return (React.createElement(DefaultICheckbox, { ...input, ...restProps, id: id, checked: !!input.value }));
};
export default Checkbox;
